"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOP_BANNER_TITLE = exports.TOP_BANNER_MOBILE_HEIGHT = exports.TOP_BANNER_IMAGE = exports.TOP_BANNER_DESKTOP_HEIGHT = exports.TOP_BANNER_BREADCRUMBS = exports.TOP_BANNER = void 0;
const TOP_BANNER = exports.TOP_BANNER = 'top-banner';
const TOP_BANNER_BREADCRUMBS = exports.TOP_BANNER_BREADCRUMBS = 'top-banner-breadcrumbs';
const TOP_BANNER_IMAGE = exports.TOP_BANNER_IMAGE = 'top-banner-image';
const TOP_BANNER_TITLE = exports.TOP_BANNER_TITLE = 'top-banner-title';
const TOP_BANNER_MOBILE_HEIGHT = exports.TOP_BANNER_MOBILE_HEIGHT = 180;
const TOP_BANNER_DESKTOP_HEIGHT = exports.TOP_BANNER_DESKTOP_HEIGHT = 280;
